import { useOperatorTitle } from './useOperatorTitle';
import { useState, type FormEvent } from 'react';
import { Navigate, useNavigate } from 'react-router';
import { useQueryClient } from '@tanstack/react-query';
import type { OperatorSession } from '@kontor/shared';
import { ApiError } from '../api';
import { operatorApi, useOperator } from './operatorApi';

/** Anmeldung der Betreiber (KON-095). Eigene Seite, eigene Zugangsdaten, keine Firmenkennung: Betreiber gehören zu keinem Mandanten. */
export function OperatorLoginPage() {
  useOperatorTitle();
  const { session } = useOperator();
  const client = useQueryClient();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  if (session) return <Navigate to="/betreiber" replace />;

  async function submit(event: FormEvent) {
    event.preventDefault();
    setError(null);
    setBusy(true);
    try {
      const res = await operatorApi<{ data: OperatorSession }>('POST', '/auth/login', { email: email.trim(), password });
      client.setQueryData(['operator-session'], res.data);
      navigate('/betreiber', { replace: true });
    } catch (e) {
      setError(e instanceof ApiError ? (e.status === 429 ? 'Zu viele Versuche. Bitte warten Sie einige Minuten.' : e.message) : 'Die Anmeldung hat nicht geklappt.');
      setPassword('');
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="login">
      <aside className="login__brand">
        <span className="brand">
          <img className="brand__mark" src="/brand/wirkia-symbol.webp" alt="" width="60" height="26" />
          <span>Wirkia Betreiber</span>
        </span>
        <div>
          <h1>Mandanten und Lizenzen</h1>
          <p>Verwaltung für uns als Betreiber von Wirkia. Mandanten haben hier keinen Zugang.</p>
        </div>
        <p className="login__foot">Jede Anmeldung und jede Änderung wird protokolliert.</p>
      </aside>
      <main className="login__main">
        <form className="card login__card" onSubmit={submit} noValidate>
          <h2>Als Betreiber anmelden</h2>
          {error && <div className="alert alert--error" role="alert">{error}</div>}
          <label className="field">
            <span>E-Mail</span>
            <input className="input" type="email" value={email} onChange={(e) => setEmail(e.target.value)} autoComplete="username" autoFocus required />
          </label>
          <label className="field">
            <span>Passwort</span>
            <input className="input" type="password" value={password} onChange={(e) => setPassword(e.target.value)} autoComplete="current-password" required />
          </label>
          <button className="btn btn--primary" type="submit" disabled={busy || !email.trim() || !password}>{busy ? 'Wird angemeldet …' : 'Anmelden'}</button>
        </form>
      </main>
    </div>
  );
}
